import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { FleetTrackerService } from "src/app/fleet-tracker.service";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-fleet-default",
	templateUrl: "./fleet-default.component.html",
	styleUrls: ["./fleet-default.component.scss"]
})
export class FleetDefaultComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];
	fleet?: APIResults.Fleet;
	sortedAssets: APIResults.FleetAsset[] = [];
	sortType = "tail";
	public brand = BrandVars;

	constructor(private fleettracker: FleetTrackerService) { }

	ngOnInit() {
		// TODO: fix up someday
		/* eslint-disable-next-line @typescript-eslint/no-this-alias */
		const me = this;
		me.subscriptions.push(me.fleettracker.currentFleet.subscribe(currentfleet => {
			me.fleet = currentfleet;
			me.sortChange(me.sortType);
		}));
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) {
			sub.unsubscribe();
		}
	}

	sortChange(sort: string) {
		this.sortType = sort;
		if (this.fleet && this.fleet.assets && this.fleet.assets.length > 0) {
			switch (sort) {
				case "tail":
					this.sortedAssets = this.fleet.assets.slice().sort((a, b) => {
						if (a.organization_name > b.organization_name) { return 1; }
						if (a.organization_name < b.organization_name) { return -1; }
						if (a.asset_name > b.asset_name) { return 1; }
						if (a.asset_name < b.asset_name) { return -1; }
						return 0;
					});
					break;
				case "type":
					this.sortedAssets = this.fleet.assets.slice().sort((a, b) => {
						// Should always be true
						if (a.asset_type_name && b.asset_type_name) {
							if (a.asset_type_name > b.asset_type_name) { return 1; }
							if (a.asset_type_name < b.asset_type_name) { return -1; }
						}
						return 0;
					});
					break;
				case "health":
					this.sortedAssets = this.fleet.assets.slice().sort((a, b) => {
						if (a.totalhimax < b.totalhimax) { return 1; }
						if (a.totalhimax > b.totalhimax) { return -1; }
						return 0;
					});
					break;
				default:
					this.sortedAssets = this.fleet.assets;
			}
		} else {
			this.sortedAssets = [];
		}
	}
}
